import { FormGroup, ValidationErrors } from '@angular/forms';

export class FormGroupWithErrors extends FormGroup {
  constructor(props: any) {
    super(props);
  }

  get allErrors() {
    const errors: Array<ValidationErrors | null> = [];
    if (this.errors) errors.push(this.errors);

    Object.keys(this.controls).map((key) => {
      if (this.controls[key].errors) {
        errors.push(this.controls[key].errors);
      }
    });

    return errors;
  }
}
